<template>
  <div class="xt-container">
    <el-row :gutter="10">
      <el-col :span="16">
        <p class="text">
          <!-- <p v-for="(part,index) in format.exerciseFormat" :key="index" class="text" > -->
          <!-- <span  v-for="(item,index) in part" :key="index"> -->
          <span  v-for="(item,index) in format.exerciseFormat" :key="index">
            <van-blank
              v-if="item.isBlank"
              :id="`blank${item.index}`"
              :index="item.index"
              :answer="item.answer"
              :user-answer="item.userAnswer"
              :is-done="isDone"
              :is-right="item.isRight"
              :is-active="currentBlank === item.index"
              @change="setCurrentBlank"
            ></van-blank>
            <span v-else v-html="item.text"></span>&nbsp;
          </span>
        </p>
      </el-col>
      <el-col :span="8">
        <van-xt-option
            :options="format.options"
            :results="selectedResults"
            @change="changeUserAnswer"
            :is-done="isDone"
        ></van-xt-option>
      </el-col>
    </el-row>
    <!-- <p v-if="isDone && exercise.explain" class="explain">
      <strong>解析：</strong>
      {{exercise.explain}}
    </p> -->
  </div>
</template>
<script>
import VanXtOption from '@/components/quizzes/hk/XTOption.vue';
import VanBlank from '@/components/quizzes/hk/XTBlank.vue';
import utils from '@/services/utils';
import { Row, Col } from 'element-ui';

export default {
  components: {
    VanXtOption,
    VanBlank,
    ElRow: Row,
    ElCol: Col,
  },
  props: {
    isDone: {
      type: Boolean,
      default: false,
    },
    exercise: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      currentBlank: 1,
      format: {
        exerciseFormat: [],
        options: [],
        totalCount: 0,
        groups: {},
      },
    };
  },
  watch: {
    exercise: {
      handler() {
        this.format = this.initText(this.exercise.text);
      },
      immediate: true,
    },
  },
  computed: {
    selectedResults() {
      return this.format.exerciseFormat.filter(item => item.isBlank);
    },
  },
  methods: {
    initText(str) {
      // eslint-disable-next-line
      str = str.replace(/\n/gm,"<br/>").replace(/@/g, '');
      const rh = /(\[\[[^[]+?\]\])/;
      const initArry = str.split(rh);
      const options = [];
      let totalCount = 0;
      const groups = {};
      const exerciseFormat = initArry.filter(text => text).map((item) => {
        if (rh.test(item)) {
          let answer = item.replace('[[', '').replace(']]', '');
          let group = null;
          if (answer.match(/#\d+#/)) {
            const [first] = answer.match(/#\d+#/);
            group = first;
            answer = answer.replace(/#\d+#/g, '').replace(/\s/g, '').replace(/^@/, '').replace(/\|{2}.*/, '');
            if (groups[first]) {
              groups[first].push(answer);
            } else {
              groups[first] = [answer];
            }
          } else if (/\|{2}/.test(answer)) {
            const [first] = answer.split('||');
            answer = first.replace(/\s/g, '').replace(/^@/, '');
          }
          totalCount += 1;
          options.push(answer.replace(/^@/, ''));
          return {
            isBlank: true,
            text: answer.replace(/^@/, ''),
            userAnswer: '',
            index: totalCount,
            selectedIndex: -1,
            isRight: false,
            answer: answer.replace(/^@/, ''),
            group,
          };
        }
        return {
          isBlank: false,
          text: item,
        };
      });
      return {
        exerciseFormat,
        options,
        totalCount,
        groups,
      };
    },
    changeUserAnswer(answer, selectedIndex) {
      // eslint-disable-next-line
      const hasBlank = this.format.exerciseFormat.filter(item => item.index === this.currentBlank)[0];
      // 判断重复选项已选的空 。length就是已经占用的资源
      // eslint-disable-next-line
      const repeatOption = this.format.exerciseFormat.filter(item => item.userAnswer === answer);
      // 判断当前的选项，重复的选项一共有几个
      // eslint-disable-next-line
      const hadRepeatAnswer = this.format.exerciseFormat.filter(item => item.answer === answer).length;
      // eslint-disable-next-line
      if (hadRepeatAnswer > 1) {
        if (repeatOption && repeatOption.length >= hadRepeatAnswer) {
          if (hasBlank.userAnswer !== answer) {
            repeatOption[0].userAnswer = '';
            repeatOption[0].isRight = false;
            repeatOption[0].selectedIndex = -1;
          }
        }
      } else if (repeatOption.length > 0) {
        repeatOption[0].userAnswer = '';
        repeatOption[0].isRight = false;
        repeatOption[0].selectedIndex = -1;
      }
      // if (repeatOption && repeatOption.length >= hadRepeatAnswer) {
      //   if (hasBlank.userAnswer && hasBlank.userAnswer !== answer) {
      //     repeatOption[0].userAnswer = '';
      //     repeatOption[0].isRight = false;
      //   }
      // }
      if (hasBlank) {
        hasBlank.userAnswer = answer;
        hasBlank.selectedIndex = selectedIndex;
        if (hasBlank.userAnswer === hasBlank.answer) {
          hasBlank.isRight = true;
        } else if (hasBlank.group) {
          const key = hasBlank.group;
          const index = utils.Array.findIndex(this.format.groups[key], answer);
          if (index > -1) {
            hasBlank.isRight = true;
          } else {
            hasBlank.isRight = false;
          }
        } else {
          hasBlank.isRight = false;
        }
      }
      if (this.currentBlank < this.format.totalCount) {
        this.currentBlank += 1;
      }
      const blankId = document.querySelector(`#blank${this.currentBlank}`);
      blankId.scrollIntoView();
    },
    setCurrentBlank(index) {
      this.currentBlank = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.xt-container {
  box-sizing: border-box;
  height: 100%;
  padding: 20px;
  .el-row {
    height: 100%;
    .el-col {
      height: 100%;
      overflow-y: auto;
      scroll-behavior: smooth;
    }
  }
  .text {
    line-height: 38px;
    font-size: 18px;
  }
  /deep/ .interval {
    display: block;
    width: 10px;
    height: 25px;
  }
  .explain {
    font-size: 18px;
    line-height: 1.4;
  }
}
</style>
